import React from 'react';
import { createBrowserRouter, RouterProvider } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";
import AuthProtected from "./AuthProtected"

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";

// Convert the route arrays into the format needed for createBrowserRouter
const routes = [
    // Public routes
    ...publicRoutes.map(route => ({
        path: route.path,
        element: (
            <NonAuthLayout>
                {route.component}
            </NonAuthLayout>
        ),
        ...(route.loader && { loader: route.loader }) // Only add loader if it exists
    })),

    // Auth protected routes
    ...authProtectedRoutes.map(route => ({
        path: route.path,
        element: (
            <AuthProtected>
                <VerticalLayout>
                    {route.component}
                </VerticalLayout>
            </AuthProtected>
        ),
        ...(route.loader && { loader: route.loader }) // Only add loader if it exists
    }))
];

const router = createBrowserRouter(routes);

const Index = () => {
    return <RouterProvider router={router} />;
};

export default Index;